
import React, {  useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";


const Topic_Filter = ({
  appliedFilters,
  show,
  onHide,
  onApplyFilter,
  onClear,
  setSelectedRange,
  selectedRange
}) => {
   const [filters, setFilters] = useState({
       name: appliedFilters?.name || "",
       status: appliedFilters?.status || "",
       published_status: appliedFilters?.published_status || "",
      from_date: appliedFilters?.from_date || "",
      to_date: appliedFilters?.to_date || "",
     });
     const handleFilterChange = (event) => {
       const { name, value } = event.target;
       setFilters({ ...filters, [name]: value });
     };
    const handleDateRange = (range) => {
      const now = new Date();
      let start = null;
      let end = null;
    
      if (range === "disabled") {
        setFilters({
          from_date: null,
          to_date: null,
        });
        setSelectedRange("");
        return;
      }
    
      switch (range) {
        case "today":
          start = end = now;
          break;
        case "yesterday":
          start = end = new Date(now.setDate(now.getDate() - 1));
          break;
        case "thisWeek":
          start = new Date(now.setDate(now.getDate() - now.getDay()));
          end = new Date(new Date().setDate(start.getDate() + 6));
          break;
        case "last7Days":
          start = new Date(new Date().setDate(now.getDate() - 6));
          end = new Date();
          break;
        case "thisMonth":
          start = new Date(now.getFullYear(), now.getMonth(), 1);
          end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          break;
        case "lastMonth":
          start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          end = new Date(now.getFullYear(), now.getMonth(), 0);
          break;
        case "customDate":
          start = end = null;
          break;
        default:
          break;
      }
    
      setFilters({
        from_date: start ? moment(start).format("YYYY-MM-DD") : null,
        to_date: end ? moment(end).format("YYYY-MM-DD") : null,
      });
    
      setSelectedRange(range);
    }
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">Filter By</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 mom_filter">
        <Form className="filter_form">
          {/* Topic Name */}
          <div>
            <label className="font_blue_14 font-500 mb-2">Topic Name</label>
            <Form.Control
              type="text"
              placeholder="Enter topic name"
              name="name"
              value={filters.name}
              onChange={handleFilterChange}
            />
          </div>

          {/* Create Date */}
          <div className="mt-3">
            <label className="font_blue_14 font-500 mb-2">Create Date</label>
            <select
              className="form-select mb-2"
              value={selectedRange}
              onChange={(e) => handleDateRange(e.target.value)}
            >
              <option value="disabled">Select Date</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="thisWeek">This Week</option>
              <option value="last7Days">Last 7 Days</option>
              <option value="thisMonth">This Month</option>
              <option value="lastMonth">Last Month</option>
              <option value="customDate">Custom Date</option>
            </select>
            {selectedRange === "customDate" && (
              <DatePicker
                selectsRange
                startDate={filters.from_date ? new Date(filters.from_date) : null}
                endDate={filters.to_date ? new Date(filters.to_date) : null}
                onChange={(update) => {
                  const [start, end] = update;
                  setFilters((prev) => ({
                    ...prev,
                    from_date: start ? moment(start).format("YYYY-MM-DD") : null,
                    to_date: end ? moment(end).format("YYYY-MM-DD") : null,
                  }));
                }}
                placeholderText="Select Custom Date"
                dateFormat="dd/MM/yyyy"
                className="ms-date-picker-input"
              />
            )}
          </div>

          {/* Published Status */}
          <div className="mt-3">
            <label className="font_blue_14 font-500 mb-2">Published Status</label>
            <Form.Select
              name="published_status"
              value={filters.published_status}
              onChange={handleFilterChange}
            >
              <option value="">Select Status</option>
              <option value="Published">Published</option>
              <option value="Draft">Draft</option>
            </Form.Select>
          </div>

          {/* Active Status */}
          <div className="mt-3">
            <label className="font_blue_14 font-500 mb-2">Status</label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">Select Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </div>
        </Form>

        <div className="offcanvas-footer mt-4 d-flex justify-content-between">
          <button className="btn blue_border" onClick={onClear}>
            Clear
          </button>
          <button
            className="btn red_button"
            onClick={() => {
              onApplyFilter(filters);
              onHide();
            }}
          >
            Apply
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Topic_Filter;
